;(function ( $ ) {

    'use strict';

    // Create the defaults once
    var pluginName = 'sgNavigationToolbar';
    var defaults = {
        'toolbarMarkup': '<div class="sg-toolbar is-active"><div class="sg-toolbar-settings">' +
            '<div class="sg-home-button"><a href="index.html">Inhaltsverzeichnis</a></div>' +
            '<div class="sg-theme-chooser"><select id="#sg-theme-chooser"></select></div></div>' +
            '<div class="sg-toolbar-navigation"></div><a class="sg-toolbar-handle" href="#">Toolbar</a></div>'
    };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {

        init: function () {
            if ($.cookie('sg-toolbar-visible') === '0' || $.cookie('sg-toolbar-visible') === undefined) {
                return;
            }
            if (!$('.sg-toolbar').length) {
                $('body').append(this.settings.toolbarMarkup);
            }
            this.$toolbar = $('.sg-toolbar');
            this.fetchNavigation();
            this.registerEvents();
            if ($.cookie('sg-toolbar-expanded') === '0') {
                this.$toolbar.removeClass('is-active');
            }
            sgThemeChooser();

        },

        fetchNavigation: function() {
            var _this = this;
            $.ajax({
                url: 'index.html',
                success: function(html) {
                    _this.renderNavigation($(html).find('.page-nav-wrapper'));
                }
            });
        },

        renderNavigation: function(navigation) {
            var _this = this;
            this.$toolbar.find('.sg-toolbar-navigation').append(navigation);
            var w = 0;
            this.$toolbar.find('a').each(function(index, item) {
                w += $(item).width() + 10;
            });
            this.$toolbar.find('.page-nav-wrapper').width(w + 10);
            // set highlight
            var tmp = window.location.href.split('/');
            var currentPage = tmp[tmp.length - 1];
            this.$toolbar.find('a[href="' + currentPage + '"]').addClass('active');
            var scrollLeft = this.$toolbar.find('a.active').offset().left - this.$toolbar.find('.page-nav-wrapper').offset().left -  ($('.sg-toolbar-navigation').width() / 2);
            $('.sg-toolbar-navigation').scrollLeft(scrollLeft);
        },

        registerEvents: function() {
            var _this = this;

            // toggle toolbar
            this.$toolbar.find('.sg-toolbar-handle').on('click', function(e) {
                e.preventDefault();
                _this.$toolbar.toggleClass('is-active');
                if (_this.$toolbar.hasClass('is-active')) {
                    $.cookie('sg-toolbar-expanded', '1');
                } else {
                    $.cookie('sg-toolbar-expanded', '0');
                }
            });
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
